import { PlanContext } from "../../context"
import { MapContext } from "./context"

export function useMapContext(selectedFieldId: number, disableSelection: boolean) {

    const { mapFactory, dispatch } = React.useContext(PlanContext)

    const [context, setContext] = React.useState<MapContext>()

    React.useEffect(() => {

        if (!context) {

            const newContext = new MapContext(mapFactory, dispatch)
            setContext(newContext)

            return () => {

                newContext.dispose()

                if (context === newContext) {
                    setContext(undefined)
                }

            }

        }


    }, [mapFactory, dispatch])


    React.useEffect(() => {

        if (context) {
            context.update({ selectedFieldId })
        }

    }, [context, selectedFieldId])


    React.useEffect(() => {

        if (context) {
            context.enableSelection(!disableSelection)
        }

    }, [context, disableSelection])

    return context

}
